import { Compass } from 'lucide-react';
import { SampleDataRibbon } from './SampleDataRibbon';
import { BrandPulseBrandTracker } from './BrandPulseBrandTracker';

export function BrandPulsePage() {
  return (
    <div className="min-h-screen bg-[#f8f9fa] p-2.5">
      <SampleDataRibbon />
      <div className="min-h-[calc(100vh-20px)] rounded-2xl bg-white border border-gray-200/80 shadow-sm overflow-hidden">
        <div className="max-w-[1600px] mx-auto p-8">
          <div className="mb-8">
            <div className="flex items-center gap-3 mb-2">
              <Compass className="w-5 h-5 text-purple-600" />
              <h2 className="text-gray-900">Brand Pulse</h2>
            </div>
            <p className="text-sm text-gray-600">
              Algorithmic brand health from online signals — Share of Search, Category Fit, Comparison Intent, and News Sentiment across the competitor cohort.
            </p>
          </div>

          <BrandPulseBrandTracker />
        </div>
      </div>
    </div>
  );
}
